import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';

@Component({
  selector: 'dialog-confirmation',
  template: `<div class="modal__content">
  <div class="modal__header">
    <h3>
      <span class="icon-warning"></span>
      <span>{{title}}</span>
    </h3>
  </div>
  <div class="modal__body">
    <p>{{prompt}}</p>
  </div>
  <div class="modal__footer text-center">
    <button cuiButton color="primary" (click)="confirm()">{{confirmText}}</button>
    <button cuiButton color="negative" (click)="reject()">{{rejectText}}</button>
  </div>
</div>`,
  styles: [``]
})
export class ConfirmationDialogComponent {

  private _title: string;
  public get title(): string { return this._title; }

  private _prompt: string;
  public get prompt(): string { return this._prompt }

  private _confirmText: string;
  public get confirmText(): string { return this._confirmText; }

  private _rejectText: string;
  public get rejectText(): string { return this._rejectText; }

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._title = 'Please Confirm';
    this._prompt = data.prompt || 'Are you sure?';
    this._confirmText = data.confirmText || 'Confirm';
    this._rejectText = data.rejectText || 'Reject';
  }

  public confirm(): void {
    return this.dialogRef.close(true);
  }

  public reject(): void {
    return this.dialogRef.close(false);
  }

}
